import React from "react";
import GlacialSkinImage from "../../../../assests/custom-cards/glacial.jpg";
import IsClinicalImage from "../../../../assests/custom-cards/is-clinical.jpg";
import MainImage from "../../../../assests/custom-cards/main.webp";

const getLogoByName = (name) => {
  const normalized = name?.toLowerCase() || "";

  if (normalized.includes("glacial")) return GlacialSkinImage;

  if (
    normalized.includes("clinical") ||
    normalized.includes("clincial")
  ) {
    return IsClinicalImage;
  }

  if (normalized.includes("leader")) return MainImage;

  return MainImage;
};

export default function CustomIcon({ webData }) {
  const logo = getLogoByName(webData?.websiteName);

  return (
    <span className="w-12 h-12 rounded-full flex justify-center items-center bg-white border">
        <img
          src={logo}
          className="size-12 rounded-full object-contain"
          alt="logo"
        />
    </span>
  );
}